import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import {Box, Typography} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';

const NoPreview = ({errorSize = 'small', ...props}) => {
  const {t} = useTranslation();
  const variant = errorSize === 'large' ? 'h4' : 'body2';
  const fontSize = errorSize === 'large' ? 48 : '';

  return (
    <Box
      {...props}
      sx={[
        {
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 'fontWeightRegular',
          fontSize: `${variant}.fontSize`,
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      <Box
        sx={{
          marginBottom: 0.5,
        }}
      >
        <BrokenImageIcon fontSize="large" color="action" style={{fontSize}} />
      </Box>
      <Typography variant="inherit" color="textSecondary" align="center">
        {t('common:thumbnailNoPreview')}
      </Typography>
    </Box>
  );
};
NoPreview.propTypes = {
  errorSize: PropTypes.string,
  sx: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default NoPreview;
